import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import ProgressBar from "./ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { getData } from "../Actions/landingAction";
import $ from "jquery";
import { toast } from "react-toastify";

const CandidateTab = ({ activeTab, addFlag, deleteFlag, profileFlag }) => {
  let navigate = useNavigate();
  // alert('he');
  const [details, setDetails] = useState([]);
  const [digitalArn,setDigitalArn]=useState(0);
  const [checkLength, setCheckLength] = useState();
  const [reference, setReference] = useState();
  const [authComplete,setAuthComplete]=useState(0);
  const [referenceClient,setReferenceClient]=useState();
  const [finalReference,setFinalReference]=useState();
  const [role,setRole]=useState("");
  const [url,setUrl]=useState();
  const [personalStatus, setPersonalStatus] = useState(0);
  const [allStatus, setAllStatus] = useState(0);
  const [verifyComplete,setVerifyComplete]=useState(false);
  // const [digiResult, setDigiResult] = useState(false);
  // const [isDigilocker, setIsDigilocker] = useState('');
  const storeLandingData = useSelector((state) => state.landingPage);
  const storeData4 = useSelector((state) => state.verifyEmail);
  const { verifyEmailData,loading: getEmailLoading, err } = storeData4;
  const dispatch = useDispatch();
  const { Data, loadingData, errorData } = storeLandingData;

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;
  const [isOnboarding, setIsOnboarding] = useState(0);

  useEffect(() => {

    if (  typeof verifyEmailData !== "undefined" &&
    verifyEmailData !== null) {
      if(verifyEmailData.status == 1){
        setVerifyComplete(true);
      }
     
    }
  }, [verifyEmailData, storeData4]);

  // if( activeTab!== "undefined" &&
  // activeTab !== null && verifyComplete==false){
  //   let errorMsg="Please verify your Email Account first  and then proceed";
  //   toast.error(errorMsg, {
  //     position: "top-right",
  //     autoClose: 5000,
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //     progress: undefined,
  //   });

  // }


  useEffect(() => {

    const role = autoLoginData?.data?.user_role;
    let ref = '';
    if(role === 'EP'){
      let list = JSON.parse(localStorage.getItem("autoLogin"));
      ref = list?.data?.reference_number;
    }else{
      let list = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      ref = list.reference_number;
      if(list?.is_digital_arn_candidate != undefined){
      setDigitalArn(list?.is_digital_arn_candidate);
      }
    }
    setReference(ref);
    // const showDigi = localStorage?.getItem('digiResponse');
    // showDigi==1?setDigiResult(true):setDigiResult(false)
    // const isDigi = localStorage?.getItem('isDigilocker');
    // isDigi == 1 ? setIsDigilocker(isDigi) : setIsDigilocker(isDigi); 
  }, []);

  const storeLandingClientData = useSelector((state) => state.landingClient);
  const { landingClientData, loadingClientData, errorClientData } = storeLandingClientData;
  let Complete = 0,
  personalComplete = 0;
  useEffect(() => {
    if (typeof landingClientData?.data !== "undefined" && landingClientData?.data !== null) {
    
      setAuthComplete(landingClientData.data.authrize_complete);
    }
  }, [landingClientData, storeLandingClientData]);

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
     
    
      setRole(autoLoginData.data.user_role);
    }
  }, [autoLoginData, autoLoginStore]);

  useEffect(() => {
    if (typeof Data?.data !== "undefined" && Data?.data !== null) {
      setPersonalStatus(Data.data);
      setDetails(Data.data.totalGroupsOfChecks);
      setIsOnboarding(Data?.data?.show_onboarding_form);
      if(landingClientData?.data?.authrize_complete === 1){
        setCheckLength(Object.keys(Data.data.totalGroupsOfChecks).length + 3);
      }else{
        setCheckLength(Object.keys(Data.data.totalGroupsOfChecks).length + 2);
      }
   
    }
  }, [Data, storeLandingData]);

  useEffect(() => {
    const pageData = async () => {
      dispatch(getData());
    };

    pageData();
  }, []);

  const ref = useRef(null);

  
  if(landingClientData?.data?.authrize_complete === 1){
    Complete++;
  }
  
  if (personalStatus.personal_completed == "1") {
    Complete++;
    personalComplete = 1;
  }
  useEffect(() => {
    if (personalStatus.personal_completed == "1") {
        let res = true;
        // Object.entries(details).map((value, index) => {
        //   if(value[1].completed == 0){
        //     console.log(value[1].completed);  
        //     res = false;
        //   }
        //   // if(value[1].name == "Education"){
        //   //   console.log(digiResult);
        //   //   console.log(isDigilocker);
        //   //   if(isDigilocker == 1 && digiResult == false){
        //   //     res = false;
        //   //   }
        //   // }
        //   if(personalStatus.personal_completed == "1" && res){
        //     setAllStatus(1);
        //   }
        // })
        res = Object.entries(details).every((value, index) => value[1].completed == 1);
        if(res && personalStatus.personal_completed == "1"){
          setAllStatus(1);
        } else {
          setAllStatus(0);
        }
       }
  },[personalStatus.personal_completed]);

  useEffect(() => {
    if (addFlag) {
        setAllStatus(0);
       }
  },[addFlag]);

  useEffect(() => {
    if (deleteFlag) {
      setAllStatus(1);
    }
  },[deleteFlag]);

  //if(personalStatus)
  // Object.entries(details).map((value, index) => {
  //   let cardClass="";
  //   let Cname="";
  //   if(value[1].completed=="true"){
  //   Complete++;
  //   }
  // }

  useEffect(() => {
    let link = ref?.current?.querySelector(".active");
    if (link) {
      link.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "end",
      });
    }
  }, [checkLength]);

  const test = () => {
    let nav = $("nav");
    if (nav) {
      let navLinks = document.querySelectorAll("nav a");
      let navLinkActive = document.querySelector(".active");
      navLinkActive.scrollIntoView({ behavior: "smooth", inline: "center" });
    }
  };

  function showError(){
    if(!allStatus){
      const msg = "Please complete the form first to submit";
      toast.dismiss();
      toast.error(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }else if(activeTab == 'Address'){
      if(!profileFlag){
        const msg = "Please complete the form first to submit";
        toast.dismiss();
        toast.error(msg, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    }
  }

  function showErrorOnboarding(name, link){
   
    if((name == "Onboarding Details" || name == "Declaration Details") && link == 0){

        const msg = `Please save the previous forms to enable ${name == "Onboarding Details" ? 'Onboarding' : 'Declaration'} form.`;
        toast.dismiss();
        toast.error(msg, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
    }

    if(personalComplete != "1"){
      const msg = `Please save the personal details to enable form.`;
      toast.dismiss();
      toast.error(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }


  }

  function checkSameLink(link){
    let arr = window?.location?.pathname.split('/')
    let lnk = link.split('/');
    if(arr.pop() != 11){
      if(lnk?.[lnk.length-1] == arr?.[arr.length-1])
      return true; 
    }
    return false;
  } 

  // if(role === "EP"){
  //   setUrl(`/case-initiation/check-detail/${reference}/candidate-profile`);
  //   }
  //   else{
  //     setUrl(`/case-initiation/check-detail/${reference}/profile`);
  //   }
  return (
    <>
      {Object.entries(details).map((value, index) => {
        if (value[1].completed == "1") {
          Complete++;
        }
      })}
      

      { digitalArn == 0 && Math.round((Complete / checkLength) * 100).toFixed(2) == "NaN" ? (
        <ProgressBar percent="" />
      ) : digitalArn == 0 && Math.round((Complete / checkLength) * 100).toFixed(2) == "0.00" ? (
        <ProgressBar
          percent={Math.round((Complete / checkLength) * 100).toFixed(0)}
        />
      ) : digitalArn == 0 ? (
        <ProgressBar
          percent={Math.round((Complete / checkLength) * 100).toFixed(0)}
        />
      ):""}

      {/* <ProgressBar percent={Math.round(Complete/checkLength*100).toFixed(2)} /> */}
      <div className="clearfix"></div>

      {/* <nav>
        <div
          className="nav nav-tabs flex-column"
          id="nav-tab"
          role="tablist"
        >
          <Link
            className={
              activeTab === "personal"
                ? "nav-item nav-link fnt-smi-bld active"
                : "nav-item nav-link fnt-smi-bld "
            }
            id="nav-personal-details-tab"
            to={`/case-initiation/check-detail/${reference}/profile`}
            
          >
            <span className="icon personal-details-icon"></span>
            <span className="title">Personal Details</span>
          </Link>
          
          <Link
            className={
              activeTab === "education"
                ? "nav-item nav-link fnt-smi-bld active"
                : "nav-item nav-link fnt-smi-bld "
            }
            id="nav-education-tab"
            to={`/case-initiation/check-detail/${reference}/3`}
          >
            <span className="icon education-icon"></span>
            <span className="title">Education</span>
          </Link>

          <Link
            className={
              activeTab === "professionalLicenceCheck"
                ? "nav-item nav-link fnt-smi-bld active"
                : "nav-item nav-link fnt-smi-bld "
            }
            id="nav-scotland-discloser-tab"
            to="/candidate-form/professional-licence-check"
          >
            <span className="icon onboarding-icon"></span>
            <span className="title">Professional Licence Check</span>
          </Link>
        </div>
      </nav> */}

      <nav id="nav" ref={ref} className="main-menu">
        <div className="nav nav-tabs flex-column" id="nav-tab" role="tablist">
        { role == "EP" && authComplete == 1 ?
            <Link
            className="nav-item nav-link fnt-smi-bld justify-content-between"
               to={'#'}
              >
               
                <span>
                  <span className="icon fas fa-feather"></span>
                  <span className="title">Authorization</span>
                </span>
              
                  <span>
                    <i
                      class="fas fa-check ml-2"
                      style={{ color: "#12B76A" }}
                    ></i>
                  </span>
  
              </Link>:""}
         {digitalArn == 0 && (!isOnboarding || role == "EP") ? 
          <Link
            className={
              activeTab === "personal"
                ? "nav-item nav-link fnt-smi-bld justify-content-between active"
                : "nav-item nav-link fnt-smi-bld justify-content-between"
            }
            id="nav-personal-reference-tab"
            to={ isOnboarding && role != "EP" ? '#' : role === "EP"?`/case-initiation/check-detail/${reference}/candidate-profile`:`/case-initiation/check-detail/${reference}/profile`}
          >
            {activeTab === "personal" && <span className="tab-count">1</span>}
            <span>
              <span className="icon fas fa-user"></span>
              <span className="title">Personal Details</span>
            </span>
            {personalComplete == 1 ? (
              <span>
                <i class="fas fa-check ml-2" style={{ color: "#12B76A" }}></i>
              </span>
            ) : (
              ""
            )}
          </Link>: "" }
          {digitalArn == 0 && Object.entries(details).map((value, index) => {
            let cardClass = "";
            let Cname = "";
            let onboardingLink=1;
            let completeStatus = 0;
            if (value[1].completed == "1") {
              Complete++;
            }
            if (value[1].name == "National Identity Check") {
              cardClass = "nav-employment-tab";
              Cname = "icon fa-solid fa-shield-halved";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "2") {
              cardClass = "nav-address-tab";
              Cname = "icon fas fa-map-location-dot";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "eaadhar") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-address-card";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "nid") {
              cardClass = "nav-employment-tab";
              Cname = "icon fa-solid fa-shield-halved";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "3") {
              cardClass = "nav-education-tab";
              Cname = "icon fas fa-book";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "4" || value[1].group_id == "22" || value[1].group_id == "24") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-briefcase";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "6") {
              cardClass = "nav-personal-reference-tab";
              Cname = "icon fas fa-thumbs-up";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "7") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-user-shield";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "10") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-vial-circle-check";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "12") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-file-contract";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "15") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-user-shield";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "8") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-landmark";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "18") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-map-location-dot";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "5") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-thumbs-up";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "9") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-rectangle-list";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "14") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-clipboard-check";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "13") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-staff-snake";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "30") {
              cardClass = "nav-employment-tab";
              Cname = "icon fa-solid fa-location-dot";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            }  else if (value[1].group_id == "20") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-university";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            }  else if (value[1].group_id == "21") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-rectangle-list";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            }  else if (value[1].group_id == "23") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-rectangle-list";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "50") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-rectangle-list";
              for(let i=0; i<Data?.data?.totalGroupsOfChecks.length-1;i++){
                if(Data?.data?.totalGroupsOfChecks[i].completed == 0){
                  onboardingLink =0;
                }
              }
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if(value[1].name == "Onboarding Details"){
              cardClass = "nav-employment-tab";
              Cname = 'icon fas fa-user'
              for(let i=0; i<Data?.data?.totalGroupsOfChecks.length-1;i++){
                if(Data?.data?.totalGroupsOfChecks[i].completed == 0){
                  onboardingLink =0;
                }
              }
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            }

            let link = `/case-initiation/check-detail/${reference}/${value[1].group_id}`;
            // if(value[1].name == "Onboarding Details"){
            //   link = `/onbordingDetailsInstaform/`
            // }
            let name = value[1].name;
            let isDisabled = role == "EP" ? false : value[1].is_disabled;

            return (
             !isDisabled ? 
              <>
             {/* {verifyComplete ?  */}
              <Link
                className={
                  activeTab === name
                    ? "nav-item nav-link fnt-smi-bld justify-content-between active"
                    : "nav-item nav-link fnt-smi-bld justify-content-between"
                }
                style={{color: personalComplete != "1" ? "red" : ""}}
                id={cardClass}
                onClick={()=>showErrorOnboarding(value[1].name, onboardingLink)} 
                // to={value[1].name == "Onboarding Details" && onboardingLink == 0 ? '' : link}
                to={ value[1].is_disabled && role != "EP" || personalComplete != "1" ? "#" : value[1].name == "Onboarding Details" || value[1].name == "Declaration Details" ? onboardingLink == 0 ? '#' : checkSameLink(link) ? '#' : link : link}
              >  
                {activeTab === name && (
                  <span class="tab-count">{index + 2}</span>
                )}
                <span>
                  <span className={Cname}></span>
                  <span className="title">{name}</span>
                </span>
                {completeStatus == 1 ? (
                  <span>
                    <i
                      class="fas fa-check ml-2"
                      style={{ color: "#12B76A" }}
                    ></i>
                  </span>
                ) : (
                  ""
                )}
              </Link>
              {/* :<Link
                className={
                  activeTab === name
                    ? "nav-item nav-link fnt-smi-bld justify-content-between active "
                    : "nav-item nav-link fnt-smi-bld justify-content-between"
                }
                id={cardClass}
              >
                {activeTab === name && (
                  <span class="tab-count">{index + 2}</span>
                )}
                <span>
                  <span className={Cname}></span>
                  <span className="title">{name}</span>
                </span>
                {completeStatus == 1 ? (
                  <span>
                    <i
                      class="fas fa-check ml-2"
                      style={{ color: "#12B76A" }}
                    ></i>
                  </span>
                ) : (
                  ""
                )}
              </Link>} */}
              </>
              :
              <></>
            );
          })}
         {digitalArn == 0 ? <Link
            className={
              activeTab === "preview"
                ? "nav-item nav-link fnt-smi-bld justify-content-between active"
                : "nav-item nav-link fnt-smi-bld justify-content-between"
            }
            onClick={showError}
            id="nav-preview-form-tab" 
            to={ allStatus === 0 || (activeTab == "Address" && !profileFlag ? true : false )? 
              '#'
              :
              `/case-initiation/profile-preview/${reference}`}
              // `/case-initiation/check-detail/${reference}/profile`}
              // '/dashboard'}
            // to={role === "EP"?`/case-initiation/check-detail/${reference}/candidate-profile`:`/case-initiation/check-detail/${reference}/profile`}
          >
            {activeTab === "preview" && <span className="tab-count">1</span>}
            <span>
              <span className="icon fas fa-user"></span>
              <span className="title">Preview Form</span>
            </span>
            {/* {allComplete == 1 ? (
              <span>
                <i class="fas fa-check ml-2" style={{ color: "#12B76A" }}></i>
              </span>
            ) : (
              ""
            )} */}
          </Link> : ""}
          {digitalArn == 1 && activeTab == "Authorization" ? <Link
            className={
              activeTab === "Authorization"
                ? "nav-item nav-link fnt-smi-bld justify-content-between active"
                : "nav-item nav-link fnt-smi-bld justify-content-between"
            }
            id="nav-preview-form-tab" 
            to="#"
              // `/case-initiation/check-detail/${reference}/profile`}
              // '/dashboard'}
            // to={role === "EP"?`/case-initiation/check-detail/${reference}/candidate-profile`:`/case-initiation/check-detail/${reference}/profile`}
          >
            {activeTab === "Authorization" && <span className="tab-count">1</span>}
            <span>
              <span className="icon fas fa-feather"></span>
              <span className="title">Authorization</span>
            </span>
            {/* {allComplete == 1 ? (
              <span>
                <i class="fas fa-check ml-2" style={{ color: "#12B76A" }}></i>
              </span>
            ) : (
              ""
            )} */}
          </Link> : ""}
          {console.log(Complete)}
        </div>
      </nav>
    </>
  );
};

export default CandidateTab;
